import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import logo from "../Images/logo.png";
import './Header.css';

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    const close = () => setMenuOpen(false);

    return (
        <header className="nalaHeader">
            <div className="headerBox">
                <Link to="/" onClick={close} className="logoLink">
                    <div className="logoWrapper shine">
                        <img className="logo" src={logo} alt="Swalih logo" />
                    </div>
                </Link>

                {/* Desktop nav */}
                <nav className="deskNav">
                    <Link to="/" className="nav-link nav-link--desk">Home</Link>
                    <Link to="/wwork" className="nav-link nav-link--desk">Work</Link>
                    <Link to="/about" className="nav-link nav-link--desk">About</Link>
                    <Link to="/contact" className="nav-link nav-link--desk">Contact</Link>
                </nav>

                {/* Mobile hamburger */}
                <button
                    className={`hamburger ${menuOpen ? 'open' : ''}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                </button>
            </div>

            {createPortal(
                <div className={`menuOverlay ${menuOpen ? 'showMenu' : ''}`}>
                    <nav className="menuLinks">
                        <Link to="/" className="nav-link" onClick={close}>Home</Link>
                        <Link to="/wwork" className="nav-link" onClick={close}>Work</Link>
                        <Link to="/about" className="nav-link" onClick={close}>About</Link>
                        <Link to="/contact" className="nav-link" onClick={close}>Contact</Link>
                    </nav>
                </div>,
                document.body
            )}
        </header>
    );
}
